// extracted by mini-css-extract-plugin
module.exports = {"viewFullLink":"_3d801d7"};